<template>
    <div class="search">
        <div class="search_content">
            <h1>Resultados de pesquisa para "<span>{{ search }}</span>"</h1>
            <ul :class="{placeholder: results.length == 0}">
                <li v-for="result in results"
                    :class="`${result.type} ${result.subtype}`"
                    :key="result.id">

                    <BetanoMag :mag="result" v-if="result.subtype == 'betano-mag'"/>
                    <PagePreview :page="result" v-else-if="result.subtype == 'page'"/>
                    <PostPreview :post="result" v-else-if="result.subtype == 'post'"/>
                    <VideoPreview :video="result" v-else-if="result.subtype == 'video'"/>
                    <router-link :to="{name: 'home'}" v-else>
                        <h2 v-text="result.title"></h2>
                    </router-link>
                </li>

                <template v-if="results.length == 0">
                    <li v-for="i in 5" :key="i">
                        <h2></h2>
                    </li>
                </template>
            </ul>
            <a @click.prevent="back" href="#" class="close">X</a>
        </div>
    </div>
</template>

<script>
    import api from "@/api"
    import BetanoMag from "@/components/Search/BetanoMag"
    import PagePreview from "@/components/Search/Page"
    import PostPreview from "@/components/Search/Post"
    import VideoPreview from "@/components/Search/Video"

    export default {
        props: {
            search: {required: true}, 
        },
        components: {
            BetanoMag,
            PagePreview,
            PostPreview,
            VideoPreview,
        },
        data() {
            return {
                results: []
            }
        },
        methods: {
            back() {
                this.$router.replace({query: null})
            },
        },
        watch: {
            search: {
                immediate: true,
                async handler() {
                    this.results = await api.search(this.search)
                },
            },
        },
        mounted() {
        },
    }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";

@keyframes blink {
    0% {
        opacity: .75;
    }
    100% {
        opacity: 1;
    }
}

.search {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 5000;
    color: var(--color-text);
    background: rgba(black, .8);
    --padding: 2rem;

    &_content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 80%;
        height: fit-content;
        height: 80%;
        margin: auto;
        background-color: var(--color-background);
        box-shadow: 0 0 80px var(--color-betano), 0 0 40px var(--color-betano), 0 0 10px var(--color-betano);
        border: 1px solid var(--color-betano);
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    h1 {
        background-color: var(--color-betano);
        margin: 0;
        padding: var(--padding) var(--padding) calc(var(--padding) * .8);
        span {
            color: var(--color-background);
        }
    }

    ul {
        margin: 0;
        list-style: none;
        padding: 0;
        overflow: auto;
        padding: var(--padding);

        li {
            margin-bottom: 1rem;
            border-bottom: 1px solid rgba($color-white, .1);
            padding-bottom: 1rem;

            h2 {
                height: 1.2em;

            }

            a {
                text-decoration: none;
            }

        }

        &.placeholder {
            animation: .5s blink ease;
            animation-direction: alternate;
            animation-iteration-count: infinite;

            h2 {
                background-image: linear-gradient(90deg, rgba(white, .5), rgba(white, 0) );
                border-radius: 1em;
            }
        }
    }

    .close {
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--color-betano);
        color: var(--color-text);
        text-decoration: none;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
    }
}

</style>
